import React, { useState, useContext } from "react";
import { useLocation } from "react-router";
import { NotificationContext } from "./Notification";
import * as Utils from "./Utils";
import LoaderPR from "./LoaderPR";
import {
  getQueryParams,
  getRawDomainFromSearch,
  getPSI,
} from "./Theme";
import PasswordInput from "./PasswordInput";
import EmailInput from "./EmailInput";
import SSOService from "./SSOService";
import { Form, HeaderForm, ContentForm, DescriptionForm, FooterForm } from "./Form";
import { AlertIcon } from "./icons/alert";

function UpdatePassword() {
  const { state } = useLocation();
  const { email: storageEmail, password: storePassword, force } = state ?? {};
  const domain = getRawDomainFromSearch();
  const id = getPSI();
  const forceUpdatePassword = force;
  const [email, setEmail] = useState(!forceUpdatePassword ? "" : storageEmail);
  const [oldPassword, setOldPassword] = useState(
    !forceUpdatePassword ? "" : storePassword
  );
  const pageTitle = !forceUpdatePassword ? "Update Password" : "Change Password";
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");

  const [missmatch, setMissmatch] = useState(false);
  const [showLoading, setLoading] = useState(false);

  const { addToast } = useContext(NotificationContext);
  const service = new SSOService();
  const queryParams = getQueryParams();

  return (
    <Form name="loginForm">
      <HeaderForm />
      <ContentForm>
        <DescriptionForm
         title={pageTitle}
        />
        {forceUpdatePassword && <div className="zds-tag zds-tag-determinal">
          <AlertIcon /> Your password must be reset every 180 days
        </div>}
        {!forceUpdatePassword && <EmailInput name="email" onChange={setEmail} />}

        {!forceUpdatePassword && (
          <PasswordInput
            onChange={(oldPassword) => setOldPassword(oldPassword)}
            name="oldpassword"
            label="Please add your old password"
            validate={false}
            autoComplete={false}
          />
        )}

        <LoaderPR showLoading={showLoading} />

        <PasswordInput
          onChange={(newPassword) => setPassword(newPassword)}
          name="password1"
          label="Please add your new password"
          validate={true}
          autoComplete={false}
        />
        <PasswordInput
          onChange={(retypeNewPassword) => {
            setMissmatch(retypeNewPassword.trim() !== password.trim());
            setRetypePassword(retypeNewPassword);
          }}
          name="retypepassword1"
          label="Confirm new password"
          validate={false}
          missmatch={missmatch}
          autoComplete={false}
        />
      </ContentForm>
      <FooterForm>
        <button
          disabled={showLoading}
          className="zds-button-primary zds-button-large"
          type="submit"
          onClick={(event) => {
            event.preventDefault();
            let hasError =
              retypePassword.trim() !== password.trim() ||
              password.trim() === "" ||
              retypePassword.trim() === "";
            hasError = hasError || missmatch;
            hasError = hasError || oldPassword.trim() === "";
            hasError = hasError || email.trim() === "";
            if (hasError) {
              addToast("All fields are required", "error");
              return;
            }
            if (oldPassword === password) {
              addToast("Oops! It looks like you’ve used this password before. To keep your account secure, please choose a new one that you haven’t used before.", "error");
              return;
            }
            setLoading(true);
            service
              .updatePassword(email, password, oldPassword)
              .then(() => {
                addToast("Password Updated Successfully", "info");
                if (id && domain) {
                  return service.login(email, password, id, domain);
                }
                Utils.redirectPage(`/login${queryParams}`, 5000);
              })
              .then((data) => {
                Utils.redirectPage(data.url);
              })
              .catch((err) => {
                if (err.changePassword === true) {
                  addToast(
                    "Admin Force To Reset Password. Please Review Your Email We Sent You A Recovery Code",
                    "error"
                  );
                  Utils.redirectPage(
                    `/passwordrecovery/${email}${queryParams}`,
                    5000
                  );
                  return;
                }
                addToast(err.error, "error");
                setLoading(false);
              });
          }}
        >
          Update
        </button>
        <button
          disabled={showLoading}
          className="zds-button-secondary zds-button-large"
          type="submit"
          onClick={(event) => {
            event.preventDefault();
            Utils.redirectPage(`/login${queryParams}`);
          }}
        >
          Cancel
        </button>
      </FooterForm>
    </Form>
  );
}

export default UpdatePassword;
